var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mic-com blank",style:(_vm.style)},[(_vm.config.blank_type===0)?_c('div',{staticClass:"blank-line",style:(_vm.lineStyle)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }